import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import PasswordInput from '../PasswordInput';
import PasswordStrengthIndicator from "./password-strength/PasswordStrengthIndicator";
import PasswordStrengthChecklist from "./password-strength/PasswordStrengthChecklist";
import {PASSWORD_STRENGTHS} from "./password-strength/constants/PasswordStrengths";
import PasswordStrengthService from "./password-strength/PasswordStrengthService";

class NewPasswordInput extends Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      password: "",
      passwordStrength: PASSWORD_STRENGTHS.NONE,
      requirementsMet: [],
      isFocused: false
    };
  }

  onPasswordChanged = (e) => {
    let password = e.target.value;
    let requirementsMet = PasswordStrengthService.processPasswordRequirements(password);
    let strengthRating = PasswordStrengthService.getStrengthRating(requirementsMet.length);

    this.setState({
      password: password,
      passwordStrength: strengthRating,
      requirementsMet: requirementsMet
    });

    this.props.onPasswordChanged(password, strengthRating === PASSWORD_STRENGTHS.STRONG)
  };

  onFocusChanged = (isFocused) => {
    this.setState({isFocused: isFocused});
  };

  render() {
    return (
        <div className="hrb-new-password-parent">
          <PasswordStrengthChecklist requirementsMet={this.state.requirementsMet} showChecklist={this.state.isFocused} />
          <PasswordInput onPasswordChanged={this.onPasswordChanged} onFocusChanged={this.onFocusChanged} onBlur={this.props.onBlur}/>
          <PasswordStrengthIndicator strength={this.state.passwordStrength}/>
        </div>
    )
  };
}

NewPasswordInput.propTypes = {
  onPasswordChanged: PropTypes.func.isRequired,
  onBlur: PropTypes.func
};

export default NewPasswordInput;